import {
	Breakpoints,
	BreakpointWrapper,
	Layout,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import {
	CarlineWithOfertas,
	FinanceData,
	Oferta,
	Promocion,
} from '../services/ofertas-service/models/ofertas';
import { Carrousel } from './carrousel';
import ModelTitleBackground from './model-title-background';
import { OfertasCardContainer } from './ofertas-card-container';

const CarrouselLayout = styled.div<{ hasOneCarline: boolean }>`
	overflow: hidden;
	position: absolute;
	right: 0;

	@media screen and (min-width: 960px) and (max-width: 1279px) {
		top: 14vh;
		position: ${(props) => props.hasOneCarline && 'unset'};
		height: ${(props) => props.hasOneCarline && '25vh'};
		align-content: ${(props) => props.hasOneCarline && 'center'};
	}

	@media screen and (min-width: 1280px) {
		height: 100vh;
		align-content: center;
	}
`;

const ModelTitleBackgroundContainer = styled.div<{
	isActive: boolean;
	hasOneCarline: boolean;
}>`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	align-content: center;

	& > div {
		display: ${(props) => !props.isActive && 'none'};
	}

	//Esto nos permite que el texto haga overflow
	& * {
		overflow: visible !important;
	}

	@media screen and (min-width: 960px) and (max-width: 1279px) {
		height: ${(props) => props.hasOneCarline && ' 25vh'};
	}
`;

const CardContainer = styled.div`
	position: relative;
	left: 0;
	width: 100vw;

	@media screen and (min-width: 1280px) {
		& > div {
			height: 100vh;
			align-content: center;
		}
	}
`;

const ModelFrameContainer = styled.div`
	@media screen and (max-width: 959px) {
		overflow-x: scroll;
	}

	@media screen and (min-width: 1280px) {
		position: relative;
	}
`;

export const ModelFrame = ({
	carline,
	hasOneCarline,
	isActive,
	isLayerVisible,
	setIsLayerVisible,
	selectedOferta,
	setSelectedOferta,
	handleLayerOnClick,
	setSelectedPromotion,
	setIsFinanceLayerVisible,
	setFinanceData,
	handleScrollToDisclaimer,
}: {
	carline: CarlineWithOfertas;
	hasOneCarline: boolean;
	isActive: boolean;
	isLayerVisible: boolean;
	setIsLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	selectedOferta: Oferta;
	setSelectedOferta: React.Dispatch<React.SetStateAction<Oferta>>;
	className: string;
	handleLayerOnClick: () => void;
	setSelectedPromotion: React.Dispatch<
		React.SetStateAction<Promocion | undefined>
	>;
	setIsFinanceLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setFinanceData: React.Dispatch<React.SetStateAction<FinanceData>>;
	handleScrollToDisclaimer: (reference: string) => void;
}): React.ReactElement => {
	return (
		<ModelFrameContainer>
			<ModelTitleBackgroundContainer
				className="model-title-background-container"
				isActive={isActive}
				hasOneCarline={hasOneCarline}
			>
				<Layout
					data-testid="layout-ofertas-title"
					appearance={{
						[Breakpoints.default]: [{ name: 'a', columns: 24 }],
						[Breakpoints.b960]: hasOneCarline
							? [
									{ name: '.', columns: 0 },
									{ name: 'a', columns: 24 },
									{ name: '.', columns: 0 },
								]
							: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 13 },
									{ name: '.', columns: 10 },
								],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 13 },
							{ name: '.', columns: 10 },
						],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 14 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b2560]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 15 },
							{ name: '.', columns: 2 },
						],
					}}
				>
					<ModelTitleBackground
						text={carline?.title.replace(/-/g, '\u2011')}
						hasOneCarline={hasOneCarline}
					/>
				</Layout>
			</ModelTitleBackgroundContainer>

			<CarrouselLayout
				className="carrousel-layout"
				hasOneCarline={hasOneCarline}
			>
				{isActive && (
					<Carrousel mediaAssets={selectedOferta.configuracion.mediaAssets} />
				)}
			</CarrouselLayout>

			<BreakpointWrapper min={Breakpoints.b1280}>
				<CardContainer className="styled-container">
					<Layout
						data-testid="layout-ofertas-card"
						appearance={{
							[Breakpoints.default]: [{ name: 'a', columns: 24 }],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1280]: [
								{ name: '.', columns: 14 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 15 },
								{ name: 'a', columns: 8 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 16 },
								{ name: 'a', columns: 6 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						{isActive && (
							<OfertasCardContainer
								className="ofertas-card-container-desktop"
								carline={carline}
								hasOneCarline={hasOneCarline}
								isMobile={false}
								isLayerVisible={isLayerVisible}
								setIsLayerVisible={setIsLayerVisible}
								selectedOferta={selectedOferta}
								setSelectedOferta={setSelectedOferta}
								handleLayerOnClick={handleLayerOnClick}
								setSelectedPromotion={setSelectedPromotion}
								setIsFinanceLayerVisible={setIsFinanceLayerVisible}
								setFinanceData={setFinanceData}
								handleScrollToDisclaimer={handleScrollToDisclaimer}
							/>
						)}
					</Layout>
				</CardContainer>
			</BreakpointWrapper>
		</ModelFrameContainer>
	);
};
